import IntlMessageFormat from 'intl-messageformat';
import { DEFAULT_LOCALE } from 'containers/LanguageProvider/constants';
import translationMessages from 'translations/fr.json';
import arabicMessages from 'translations/ar.json';

export const arrayTranslate = (translator: Function) => (
  messages: any,
  isValidating: boolean = false,
) => {
  if (!messages) return '';
  if (isValidating) {
    return Object.keys(messages).reduce(
      (msg, key) => ({ ...msg, [key]: translator(...messages[key]) }),
      {},
    );
  }
  return translator({ ...messages });
};
export const translate = (message: any, props: any, values?: any): string => {
  return props.intl.formatMessage(message, values);
};
export interface Dictionary {
  [index: string]: string;
}

export const localTranslate = (
  message: string,
  /* istanbul ignore next */
  locale: string = DEFAULT_LOCALE,
) => {
  const messageByDictionnary: Dictionary =
    locale === 'fr' ? translationMessages : arabicMessages;

  const translate = new IntlMessageFormat(
    messageByDictionnary[message],
    locale,
  );
  return translate.format() as any;
};
